import { GetStaticProps, InferGetStaticPropsType, NextPage } from 'next';

import {
  CookiePolicyDocument,
  CookiePolicyQuery,
  CookiePolicyQueryVariables,
  FooterDocument,
  FooterQuery,
  FooterQueryVariables,
  NavigationDocument,
  NavigationQuery,
  NavigationQueryVariables,
} from '@/api';
import { addApolloState, initializeApollo } from '@/api/apolloClient';
import { Layout } from '@/components/layout/Layout';
import { Seo } from '@/components/Seo';
import EnhancedPolicyPageWrapper from '@/components/shared/EnhancedPolicyPageWrapper';

export const getStaticProps: GetStaticProps = async () => {
  const client = initializeApollo();

  // prefetch
  await client.query({ query: NavigationDocument });
  await client.query({ query: CookiePolicyDocument });
  await client.query({ query: FooterDocument });

  const { data: footerData } = await client.query<
    FooterQuery,
    FooterQueryVariables
  >({ query: FooterDocument });

  const { data: headerData } = await client.query<
    NavigationQuery,
    NavigationQueryVariables
  >({ query: NavigationDocument });

  const { data: cookiePolicy } = await client.query<
    CookiePolicyQuery,
    CookiePolicyQueryVariables
  >({
    query: CookiePolicyDocument,
  });
  return addApolloState(client, {
    props: {
      cookiePolicy,
      footerData,
      headerData,
    },
  });
};

export type TableRowType = string[];

export type BulletType = {
  text: string;
  isIndented: boolean;
};

const CookiePolicy: NextPage<
  InferGetStaticPropsType<typeof getStaticProps>
> = ({ footerData, headerData, cookiePolicy }) => (
  <Layout footerData={footerData} headerData={headerData} invertedColor>
    <Seo seo={cookiePolicy?.cookiePolicy.data?.attributes?.seo} />
    <EnhancedPolicyPageWrapper
      data={cookiePolicy?.cookiePolicy.data?.attributes?.cookiePolicy}
    />
  </Layout>
);

export default CookiePolicy;
